import classNames from 'classnames'

import style from './style.scss'

type Option = {
  label: string
  value: string
}

type Props = {
  options: Option[]
  value: string
  onChange: (value: string) => void
}

function Toggle({ value, options, onChange }: Props) {
  return (
    <div className={style.wrapper}>
      {options.map((option) => (
        <button
          key={option.value}
          className={classNames(style.button, {
            [style.active]: value === option.value,
          })}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default Toggle
